import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { paymentService } from "../../../../../../services/payment.service";
import { studentService } from "../../../../../../services/student.service";
import { ButtonLike } from "../../../../../../shared/ui/ButtonLike/ButtonLike";
import { CourseDataInfo } from "../../../../../../types";

interface CourseRightBlockPreviewProps {
  courseDetails: CourseDataInfo | undefined;
  courseId: string | undefined;
}

export const CourseRightBlockPreview = ({
  courseDetails,
  courseId,
}: CourseRightBlockPreviewProps) => {
  const nav = useNavigate();
  const [progress, setProgress] = useState(false);
  const navigate = useNavigate();

  const courseClicked = () => {
    navigate(`/course/learn/${courseId}/${courseDetails?.student_id}`);
  };

  async function navigateToFreeCourse(courseId: string) {
    const response = await studentService.addFreeCourse(courseId || "");
    nav(`/course/learn/${courseId}/${response.data.id}`);
  }

  async function navigateToPayment(courseId: string) {
    setProgress(true);
    try {
      const response = await paymentService.getPayment(courseId || "");
      setProgress(false);
      if (response && response.data.url_pay) {
        window.location.href = response.data.url_pay;
      } else {
        nav("/error");
        setProgress(false);
      }
    } catch (error) {
      console.error("Ошибка при получении данных об оплате:", error);
      nav("/error");
      setProgress(false);
    }
  }

  return (
    <Box
      sx={{
        "@media (max-width:1000px)": {
          width: "100%",
          maxWidth: "unset",
        },
      }}>
      <Box
        sx={{
          width: "100%",
          overflow: "hidden",
          borderRadius: "8px",
          marginBottom: "24px",
        }}>
        <Box
          sx={{
            width: "100%",
            height: "auto",
            display: "flex",
            justifyContent: "center",
          }}>
          {courseDetails?.video ? (
            <video
              className="vid-preview"
              src={courseDetails.video}
              controls
              controlsList="nodownload"
              style={{
                maxWidth: "100%",
                maxHeight: "500px",
              }}
            />
          ) : (
            <img
              style={{
                maxWidth: "100%",
                maxHeight: "500px",
                borderRadius: "8px",
              }}
              src={courseDetails?.preview}
              alt="Заглушка"
            />
          )}
        </Box>
      </Box>
      <Box
        sx={{
          borderRadius: "8px",
          border: "1px solid rgba(1, 18, 36, 0.08)",
          display: "flex",
          padding: "32px 24px",
          flexDirection: "column",
          alignItems: "flex-start",
        }}>
        <Box>
          <Typography
            sx={{
              fontSize: "36px",
              fontWeight: 800,
              color: "#000",
            }}>
            {courseDetails?.price && courseDetails?.price > 0
              ? courseDetails.price + "₸"
              : "Бесплатно"}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            height: "auto",
            marginTop: "24px",
            gap: "16px",
          }}>
          {courseDetails?.is_pay ? (
            <Button
              sx={{
                padding: "10px 16px",
                borderRadius: "8px",
              }}
              fullWidth
              variant="contained"
              disabled={progress}
              onClick={() => courseClicked()}>
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: 800,
                  color: "#fff",
                  textTransform: "none",
                }}>
                Перейти к курсу
              </Typography>
            </Button>
            ) : courseDetails?.price === 0 ? (
            <Button
              sx={{ padding: "10px 16px", borderRadius: "8px" }}
              fullWidth
              variant="contained"
              disabled={progress}
              onClick={() => navigateToFreeCourse(courseId || "")}
            >
              <Typography sx={{ fontSize: "16px", fontWeight: 800, color: "#fff", textTransform: "none" }}>
                Начать бесплатно
              </Typography>
            </Button>
            ) : (
            <Button
              sx={{
                padding: "10px 16px",
                borderRadius: "8px",
              }}
              fullWidth
              variant="contained"
              disabled={progress}
              onClick={() => navigateToPayment(courseId || "")}>
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: 800,
                  color: "#fff",
                  textTransform: "none",
                }}>
                Купить курс
              </Typography>
            </Button>
          )}
          <ButtonLike />
        </Box>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 400,
            mt: "16px",
            color: "#808992",
            alignSelf: "center",
          }}>
          Гарантия возврата денег - 30 дней
        </Typography>
      </Box>
    </Box>
  );
};
